// extracted by mini-css-extract-plugin
export default {"item":"DndList_item__jiSXr","itemDragging":"DndList_itemDragging__Bpb09","symbol":"DndList_symbol__CpC-m"};